import { render, staticRenderFns } from "./UsersNewsletter.vue?vue&type=template&id=0739c921"
import script from "./UsersNewsletter.vue?vue&type=script&lang=js"
export * from "./UsersNewsletter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports